// Clinic-wide date helpers. Timestamps are stored in UTC on the backend and every
// user-facing display/calculation runs on IST (Asia/Kolkata) — regardless of the
// browser's own timezone.
export const IST_TZ = 'Asia/Kolkata';

export const fmtDateIST = (d) =>
  d ? new Date(d).toLocaleDateString('en-IN', { timeZone: IST_TZ, day: '2-digit', month: 'short', year: 'numeric' }) : '—';

export const fmtDateTimeIST = (d) =>
  d ? new Date(d).toLocaleString('en-IN', {
    timeZone: IST_TZ, day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
  }) : '—';

export const fmtTimeIST = (d) =>
  d ? new Date(d).toLocaleTimeString('en-IN', { timeZone: IST_TZ, hour: '2-digit', minute: '2-digit' }) : '—';

/** 'yyyy-mm-dd' key of the given instant's IST calendar day (en-CA formats ISO-style). */
export const istDayKey = (d) => new Date(d).toLocaleDateString('en-CA', { timeZone: IST_TZ });

/** Whole IST calendar days from `d` until now (0 = today in IST, 1 = yesterday, …). */
export const daysSinceIST = (d) => {
  if (!d) return null;
  const MS_DAY = 86_400_000;
  const dayNumber = (x) => Math.floor(Date.parse(`${istDayKey(x)}T00:00:00Z`) / MS_DAY);
  return dayNumber(new Date()) - dayNumber(d);
};
